import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export const ForWhom = () => {
  return <Section className="bg-beige/40" data-id="element-83">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-84">
        {/* Who is this for */}
        <div className="bg-white rounded-3xl p-8 md:p-10 shadow-soft" data-id="element-85">
          <h3 className="text-2xl font-serif font-bold text-charcoal mb-8 border-b border-border pb-4" data-id="element-86">
            Este método ES para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-87">
            {['Madres en USA que sienten que el estrés del país les está robando la alegría de criar.', 'Mujeres que aman a sus hijos pero detestan la versión de sí mismas que grita.', 'Madres que trabajan y llegan a casa con el "tanque de paciencia" en cero.', 'Aquellas que quieren romper patrones generacionales de disciplina agresiva.'].map((text, i) => <li key={i} className="flex items-start gap-4" data-id="element-88">
                <CheckCircle2 className="text-terracotta shrink-0 mt-1" size={24} data-id="element-89" />
                <span className="text-charcoal/80 text-lg leading-relaxed" data-id="element-90">
                  {text}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Who is this NOT for */}
        <div className="bg-white/50 rounded-3xl p-8 md:p-10 border border-border/50" data-id="element-91">
          <h3 className="text-2xl font-serif font-bold text-charcoal/60 mb-8 border-b border-border/50 pb-4" data-id="element-92">
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-93">
            {['Personas que buscan soluciones mágicas sin aplicar ningún cambio personal.', 'Padres que creen que el miedo es la única forma de obtener respeto.', 'Quienes no están dispuestos a dedicar 5 minutos al día para leer y practicar.'].map((text, i) => <li key={i} className="flex items-start gap-4 opacity-80" data-id="element-94">
                <XCircle className="text-charcoal/40 shrink-0 mt-1" size={24} data-id="element-95" />
                <span className="text-charcoal/70 text-lg leading-relaxed" data-id="element-96">
                  {text}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
};